import { DataKeys } from "../../types";
import { useLang } from "../Context";
import { HealthSection } from "../health/HealthSection";
import { HealthSectionHeader } from "../health/HealthSectionHeader";
import {
    getLocalized,
    HealthLang,
    LocalizedString,
} from "../health/healthTypes";
import { healthAimmaDoctorSectionContentOffset } from "../health/healthLayout";
import {
    HEALTH_BG_GREY,
    healthCardBody,
    healthCardTitle,
} from "../health/healthVisualStyles";

interface EducationInstitutionSectionProps {
    data: DataKeys;
}

export function EducationInstitutionSection({
    data,
}: EducationInstitutionSectionProps) {
    const { lang } = useLang();
    const hLang = lang as HealthLang;
    const cards = (data.cards as DataKeys[]) ?? [];

    return (
        <HealthSection
            id="institution"
            ariaLabelledBy="institution-title"
            childPage
            style={{ backgroundColor: HEALTH_BG_GREY }}
        >
            <HealthSectionHeader
                eyebrow={getLocalized(data.eyebrow as LocalizedString, hLang)}
                title={getLocalized(data.title as LocalizedString, hLang)}
                titleId="institution-title"
                subtitle={getLocalized(data.intro as LocalizedString, hLang)}
            />
            <div
                className={`${healthAimmaDoctorSectionContentOffset} grid gap-4 md:grid-cols-2 lg:grid-cols-4`}
            >
                {cards.map((card, index) => (
                    <article
                        key={index}
                        className="rounded-xl border border-grey-100 bg-white p-5 shadow-sm"
                    >
                        <h3 className={healthCardTitle}>
                            {getLocalized(card.title as LocalizedString, hLang)}
                        </h3>
                        <p className={`${healthCardBody} mt-2 text-sm`}>
                            {getLocalized(card.text as LocalizedString, hLang)}
                        </p>
                    </article>
                ))}
            </div>
        </HealthSection>
    );
}
